import React, { useState } from 'react';
import './CTASection.scss';
import getLifetimeCheckoutLink from 'services/Subscriprion/getLifetimeCheckoutLink';
import { trackLifetimeCheckoutClick } from 'utils/tracking';
import { useUser } from 'hooks/user';
import { useAppContext } from 'hooks/app';
import { Modals } from 'constants/modals';
import { useCaptureAbandonedCheckout } from 'hooks/abandonedCheckout';

const CTASection: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { user } = useUser();
  const { openModal } = useAppContext();
  const { capture } = useCaptureAbandonedCheckout();

  const handleCTA = async () => {
    trackLifetimeCheckoutClick('Lifetime Plan', 0);
    if (!user?.id) {
      openModal?.(Modals.LEAD_CAPTURE, { planType: "4", planName: "Lifetime Plan" });
      return;
    }
    capture({ email: user.email, source: 'cta', plan: 'Lifetime Plan' });
    setLoading(true);
    try {
      const url = await getLifetimeCheckoutLink();
      window.location.href = url;
    } catch {
      setLoading(false);
    }
  };

  return (
    <section className="cta-section">
      <h2>
        Ready to Unlock <span className="highlight">Lifetime Success?</span>
      </h2>
      <p className="cta-description">
        Secure the deal of the decade before the countdown hits zero. Never pay monthly again.
      </p>
      <div className="cta-button-wrapper">
        <button
          onClick={handleCTA}
          disabled={loading}
          className="btn-secondary-cta"
        >
          {loading ? 'Redirecting...' : 'Claim Lifetime Access Now'}
        </button>
      </div>
    </section>
  );
};

export default CTASection;
